import localFont from "next/font/local";

export const volteFont = localFont({
  src: [
    {
      path: "../../../public/fonts/autocan/Volte-Light.woff2",
      weight: "300",
    },
    {
      path: "../../../public/fonts/autocan/Volte-Regular.woff2",
      weight: "400",
    },
    {
      path: "../../../public/fonts/autocan/Volte-Medium.woff2",
      weight: "500",
    },
    {
      path: "../../../public/fonts/autocan/Volte-Semibold.woff2",
      weight: "600",
    },
    {
      path: "../../../public/fonts/autocan/Volte-Bold.woff2",
      weight: "700",
    },
  ],
  variable: "--font-volte",
});

export const larsseitFont = localFont({
  src: [
    {
      path: "../../../public/fonts/kijiji/Larsseit-Regular.woff2",
      weight: "400",
    },
    {
      path: "../../../public/fonts/kijiji/Larsseit-Medium.woff2",
      weight: "500",
    },
  ],
  variable: "--font-larsseit",
});

export default {};
